import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import * as generic from '../../../components/Generico';
import { AccionistaService } from '../../../service/AccionistaService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FileComponent } from '../../../components/FileComponent';
import { Dialog } from 'primereact/dialog';
import { AnexosComponent } from '../../../components/AnexosComponent';
import { AccionistaDeclaracion } from '../../../models/ficha/AccionistaDeclaracion';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const Declaracion = ({ toast, id, back, permss, catalogos, setDialogInstruccion, urls, estado, reiniciar, soloLectura }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new AccionistaDeclaracion({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues });
    const accionistaServ = new AccionistaService();
    const { inArea, inDrop } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } =
        FileComponent({ tipo: 'accionistaPn', toast, unuevo: 'ficha/accionista/store', udelete: 'ficha/accionista/eliminar-anexo', permss, id });
    const [loadReport, setLoadReport] = useState(false);
    const [dialogAnexos, setDialogAnexos] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        editarFicha();
        // eslint-disable-next-line
    }, [id]);

    const editarFicha = () => {
        if (id == null) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        accionistaServ.consultarAccionista(id, 'seccion4').then(res => {
            if (!res.data.accionista) {
                return;
            }
            const _accionista = res.data.accionista;

            reset(generic.renewValues(_accionista, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        data.id = id;
        data.seccion = 'seccion4';
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
        setIsSaving(true);

        accionistaServ.editarAccionista(data).then(res => {
            setDialogInstruccion(true);
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const generarReporte = () => {
        setLoadReport(true);
        accionistaServ.descargar(id, { tipoFrmEmpresa: catalogos?.tipoFrmEmpresa }).then(res => {
            generic.downloadPdf(res, id + '-Formulario-Accionista-PN.pdf');
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const subirReporte = () => {
        setDialogAnexos(true);
    }

    const enviar = () => {
        enviarFormulario(id, `ficha/accionista/enviar?tipoFrmEmpresa=${catalogos?.tipoFrmEmpresa ?? ''}`, 'empleado');
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <>
            <form id="declaracionAccionistaForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                <Panel header={generic.renderPanelHeader('8', 'DECLARACIÓN', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Términos de la Declaración</span>
                        </div>
                        {omodel.strDeclara}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('9', catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' ? 'TRATAMIENTO DE DATOS' : 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-shield text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                        </div>
                        {!esTipoEspecial && omodel.strAutorizacionTratamientoDatos}
                        {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' && omodel.strToyota}
                        {catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && omodel.strDifare}
                    </div>
                </Panel>

                {omodel.model.uso_dato_personal.table && (
                    <Panel header={generic.renderPanelHeader('', 'CONSENTIMIENTO PARA EL USO DE DATOS PERSONALES', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                        <div className="formgrid grid align-items-center">
                            <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-4">
                                {omodel.strConceder}
                            </div>

                            {inDrop('uso_dato_personal', generic.estadosSiNo, { lab: 'nombre' }, 4)}

                            <div className="field col-8 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                                {omodel.strActividad}
                            </div>
                        </div>
                    </Panel>
                )}

                <Panel header={generic.renderPanelHeader('10', 'ANEXOS', 'pi pi-paperclip')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500 mb-0">
                            <div className="flex align-items-center gap-2 mb-3">
                                <i className="pi pi-file text-yellow-600 text-lg"></i>
                                <span className="font-bold text-yellow-900">Documentos requeridos</span>
                            </div>
                            <ul className="pl-4 m-0">
                                {catalogos?.anexosRequisitos?.map((req, index) => (
                                    <li key={index} className="mb-1">{req}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </Panel>

                {!['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa) && (
                    <Panel header={generic.renderPanelHeader('11', 'OBSERVACIONES', 'pi pi-comment')} className="panel-ficha shadow-1 mb-4">
                        <div className="formgrid grid">
                            {inArea('observacion', 5, 9000, 12)}
                        </div>
                    </Panel>
                )}

                <BottomActionBar
                    formId="declaracionAccionistaForm"
                    onPrev={back}
                    onSave={catalogos?.tipoFrmEmpresa !== 'FRM_DIFARE'}
                    onGenerate={generarReporte}
                    onSend={enviar}
                    onAttachments={subirReporte}
                    loading={loadReport || isSaving}
                    isReadOnly={soloLectura}
                    enableExtras={id != null}
                />
            </form>
            <Dialog visible={dialogAnexos} header="Gestión de Anexos" modal className="p-fluid modal-ssize" onHide={() => setDialogAnexos(false)} style={{ width: '800px' }}>
                <AnexosComponent tipo="accionistaPn" urls={urls} idp={id} toast={toast} permss={permss} setDialogSubir={setDialogAnexos} reiniciar={reiniciar} estado={estado} soloLectura={soloLectura} />
            </Dialog>
        </>
    );
}
